export const API_ROUTES = {
    LOGIN: "/auth/login",
    ME: "/auth/me",
    REGISTER: "/auth/register",
    MAINTENANCE_FETCH_ALL: "preferences/fetchAll"
};
